import { render, staticRenderFns } from "./LiveView.vue?vue&type=template&id=53dadfe4&"
import script from "./LiveView.vue?vue&type=script&lang=js&"
export * from "./LiveView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports